var map = {
	"./partner1.1.png": 2038,
	"./partner1.10.png": 3892,
	"./partner1.11.png": 3837,
	"./partner1.12.png": 2214,
	"./partner1.13.png": 8543,
	"./partner1.14.png": 7216,
	"./partner1.15.png": 2041,
	"./partner1.16.png": 8949,
	"./partner1.17.png": 5547,
	"./partner1.2.png": 6013,
	"./partner1.3.png": 9735,
	"./partner1.4.png": 5979,
	"./partner1.5.png": 1154,
	"./partner1.6.png": 2121,
	"./partner1.7.png": 4000,
	"./partner1.8.png": 8743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4689;